import "./index.scss"

require.context("./static", true, /\.svg|jpg$/)
